export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M5.96 13.59c-.18-.05-.37-.04-.55.01l-2.85.9.44-1.72a.997.997 0 00-.27-.97C1.63 10.75 1 9.38 1 7.91 1 4.78 3.99 2 8 2s7 2.78 7 5.92-2.99 5.92-7 5.92c-.71 0-1.39-.09-2.04-.26v.01zm-3.92-1.05C.77 11.32 0 9.7 0 7.92 0 4.1 3.58 1 8 1s8 3.1 8 6.92-3.58 6.92-8 6.92c-.79 0-1.56-.1-2.29-.29l-2.85.9a.996.996 0 01-1.27-1.2l.44-1.72.01.01z\" clip-rule=\"evenodd\"/><path d=\"M10.87 7.25H5.12c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5.75c.28 0 .5.22.5.5s-.22.5-.5.5zm-1.99 3H5.13c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3.75c.28 0 .5.22.5.5s-.22.5-.5.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};